<template>
  <div class="search-layout">
    <template v-if="mapVisible">
      <div class="search-layout-map">
        <div class="search-layout-map-header-mobile">
          <button
            class="button is-primary is-small tablet:hidden"
            @click="filterOpen = true"
          >
            {{ $texts('search.filterTitle') }}
          </button>
        </div>
        <div v-show="sidebarVisible" class="search-layout-map-sidebar">
          <div class="search-layout-sidebar">
            <div class="search-header belowTablet:!hidden">
              <div class="search-header-left is-filter">
                {{ $texts('search.filterTitle') }}
              </div>
            </div>
            <slot name="sidebar" />
            <div class="search-layout-sidebar-bottom tablet:hidden">
              <button
                class="button is-primary is-fullwidth"
                @click="filterOpen = false"
              >
                {{ buttonTitle }}
              </button>
            </div>
          </div>
        </div>
        <div class="search-layout-map-results">
          <slot name="results" />
          <div v-if="$slots.selected" class="search-layout-map-selected">
            <slot name="selected" />
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="page-search main">
        <slot name="pageHeader" />
        <div class="section !pt-0">
          <div class="container">
            <div class="search-layout-grid">
              <div class="search-layout-grid-left">
                <div v-show="sidebarVisible" class="search-layout-sidebar">
                  <div class="search-header belowTablet:hidden">
                    <div class="search-header-left is-filter">
                      {{ $texts('search.filterTitle') }}
                    </div>
                  </div>
                  <slot name="sidebar" />
                  <div class="search-layout-sidebar-bottom tablet:hidden">
                    <button
                      class="button is-primary is-fullwidth"
                      @click="filterOpen = false"
                    >
                      {{ buttonTitle }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="search-layout-grid-right">
                <slot name="resultsHeader" />
                <slot name="selected" />
                <slot name="results" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  mapVisible?: boolean
  total: number
}>()

const filterOpen = defineModel<boolean>('filterOpen')

const { isMobile } = useViewport()
const { $texts } = useEasyTexts()

const sidebarVisible = computed(() => !isMobile.value || filterOpen.value)

const buttonTitle = computed(() => {
  if (!isMobile.value) {
    return ''
  }

  if (props.total === 1) {
    return $texts('search.showResultsSingle')
  }

  return $texts('search.showResults').replace(
    '@count',
    props.total.toString(),
  )
})
</script>

<style>
@reference '~/assets/css/tailwind.css';
.selected-terms {
  @apply pb-size-5;
}

.search-layout-map {
  @apply fixed top-0 left-0 h-screen w-full bg-background;
  @apply tablet:grid;
  z-index: 999999;
  @variant tablet {
    grid-template-columns: 18rem 1fr;
  }
  @variant desktop {
    grid-template-columns: 20rem 1fr;
  }
  @variant widescreen {
    grid-template-columns: 24rem 1fr;
  }
}
.search-layout-map-results {
  @apply relative;
  @apply belowTablet:absolute belowTablet:top-0 belowTablet:left-0 belowTablet:h-full belowTablet:w-full;
}
.search-layout-map-sidebar {
  @apply p-size-4;
}
.search-layout-map-selected {
  @apply absolute left-0 py-[1rem] pt-[1rem] pb-0;
  @apply tablet:top-0 tablet:p-size-5;
  z-index: 10000;
  max-width: calc(100% - 5rem);

  .selected-terms {
    @apply pb-0;
  }
}

.search-layout-sidebar {
  @apply tablet:block;
  @apply belowTablet:fixed belowTablet:top-0 belowTablet:left-0 belowTablet:h-full belowTablet:w-full belowTablet:bg-background belowTablet:px-[1rem] belowTablet:pt-[1rem] belowTablet:pb-[8rem];
  @variant belowTablet {
    z-index: 999999999;
    overflow: auto;
  }
}
.search-layout-sidebar-bottom {
  @apply fixed bottom-0 left-0 w-full border-t border-solid border-border bg-background p-[1rem] belowTablet:flex belowTablet:justify-center;
  z-index: 100;

  & button {
    @apply belowTablet:flex belowTablet:w-full belowTablet:justify-center;
  }
}
.search-layout-map-header-mobile {
  @apply absolute top-0 left-0 p-[1rem];
  z-index: 10000;
}

.search-layout-grid {
  @apply tablet:grid;
  @variant tablet {
    grid-gap: 1rem;
    grid-template-columns: 2fr 5fr;
  }
  @variant desktop {
    grid-template-columns: 1fr 3fr;
  }
}
</style>
